import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useQuery } from "@tanstack/react-query";

export const OPENING_TIMES_OPEN_STATUS = 1;

export type OpeningTimesMethodStatus = {
  status: number;
  next_available?: string;
};

export type OpeningTimesStatusResponse = Record<
  string,
  OpeningTimesMethodStatus
>[];

const useOpeningTimesStatusQuery = () => {
  const branchId = useBranchId();

  return useQuery<
    OpeningTimesStatusResponse,
    Error,
    Record<string, OpeningTimesMethodStatus>
  >({
    queryKey: ["openingTimesStatus", branchId],
    queryFn: () =>
      get2(
        `/internal/anonymous/websites/v3/openingTimes/status/${branchId}`
      ),
    enabled: branchId !== -1 && branchId != null,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
};

export default useOpeningTimesStatusQuery;
